import { useCustomerProfileAccount } from '../profile';

export const useIsDynamicPricingAccount = () => {
  const { currentAccount, isLoading } = useCustomerProfileAccount();
  const isDynamicPricingAccount = currentAccount?.hasDynamicPricing;

  return { isDynamicPricingAccount, isLoading };
};
